import axios from "axios";
import Config from "../../Config";
const BASE_URL = Config.baseUrl;

class DashboardServices {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    };
  }

  async fetchChartData(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/dash_stats`,
        payload,
        this.getHeaders()
      );
      return {
        status: response?.data?.data?.status_code || null,
        message: response?.data?.data?.message || null,
        data: response?.data?.data?.data || null,
      };
    } catch (error) {
      return {
        status: error?.response?.data?.data?.status_code || null,
        message: error?.response?.data?.data?.reason || null,
        data: error?.response?.data?.data?.data || null,
      };
    }
  }

  async fetchAppStats() {
    try {
      const response = await axios.get(
        `${BASE_URL}/app_stats`,
        this.getHeaders()
      );
      return {
        status: response?.data?.data?.status_code || null,
        message: response?.data?.data?.message || null,
        data: response?.data?.data?.data || null,
      };
    } catch (error) {
      return {
        status: error?.response?.data?.data?.status_code || null,
        message: error?.response?.data?.data?.reason || null,
        data: error?.response?.data?.data?.data || null,
      };
    }
  }
}
const dashboardServices = new DashboardServices();
export default dashboardServices;
